import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export function DateRangePicker({ onChange, ranges, weekStartsOn, maxDate, monthsShown = 1 }) {
  const committedStart = ranges?.[0]?.startDate || null;
  const committedEnd = ranges?.[0]?.endDate || null;

  // Tracks the first click before the user picks the end date
  const [pendingStart, setPendingStart] = useState(null);

  const displayStart = pendingStart ?? committedStart;
  const displayEnd = pendingStart ? null : committedEnd;

  return (
    <DatePicker
      inline
      selectsRange
      startDate={displayStart}
      endDate={displayEnd}
      onChange={(dates) => {
        const [start, end] = dates;
        if (start && !end) {
          // First click — show highlight but don't commit yet
          setPendingStart(start);
        } else if (start && end) {
          // Second click — full range selected, commit and reset pending
          setPendingStart(null);
          onChange({
            selection: {
              startDate: start,
              endDate: end,
              key: "selection",
            },
          });
        }
      }}
      maxDate={maxDate}
      calendarStartDay={weekStartsOn}
      monthsShown={monthsShown}
    />
  );
}

export default DateRangePicker;
